module.exports = __webpack_public_path__ + "static/4_mobile-21ad8633c4a2d17b70e5fe37371292e8.png";